import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import BottomNavigation from './BottomNavigation';
// Import story data
import theMissingHourData from '../story/the-missing-hour/characters_data.json';

// Story configuration
const AVAILABLE_STORIES = {
  'the-missing-hour': {
    id: 'the-missing-hour',
    title: 'The Missing Hour',
    description: 'Laura Palmer murder investigation in Twin Peaks',
    data: theMissingHourData,
    imagePath: './story/the-missing-hour/images/'
  }
  // Future stories can be added here
};

function Contacts() {
  const navigate = useNavigate();
  
  // Get selected story from sessionStorage
  const selectedStoryId = sessionStorage.getItem('selectedStory') || 'the-missing-hour';
  const currentStory = AVAILABLE_STORIES[selectedStoryId];
  
  console.log('Contacts Component - Loading story:', selectedStoryId);
  console.log('Story data:', currentStory);
  
  // Transform character data to match our contact display format
  const contacts = currentStory.data.characters.map((char, index) => ({
    id: char.id, // Use the actual character ID from the JSON
    name: char.name,
    department: char.role.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
    initial: char.name.split(' ')[0][0],
    photo: char.profile_photo,
    relation: char.connection_to_victim,
    description: char.background,
    role: char.role, // Keep the original role for conditional rendering
    // Store the full character data for the detail view
    characterData: char
  }));

  // Sort contacts alphabetically by name
  contacts.sort((a, b) => a.name.localeCompare(b.name));

  // Group contacts by first letter of their name
  const groupedContacts = contacts.reduce((groups, contact) => {
    const firstLetter = contact.name.charAt(0).toUpperCase();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(contact);
    return groups;
  }, {});

  // Get alphabet letters that have contacts
  const alphabetLetters = Object.keys(groupedContacts).sort();



  return (
    <div className="contacts-container">
      <Header />
      
      <div className="page-title-section">
        <h2>Contact Directory</h2>
      </div>
      
      <div className="contacts-list">
        {alphabetLetters.map(letter => (
          <div key={letter}>
            <div className="alphabet-header">{letter}</div>
            {groupedContacts[letter].map(contact => (
              <div 
                key={contact.id} 
                className="contact-item"
                onClick={() => navigate(`/contact/${contact.id}`)}
              >
                <div className="contact-avatar">
                  {contact.photo && contact.photo.startsWith('/story/') ? (
                    <img src={contact.photo} alt={contact.name} className="contact-photo" />
                  ) : (
                    <span className="contact-initial">{contact.initial}</span>
                  )}
                </div>
                <div className="contact-info">
                  <div className="contact-name">{contact.name}</div>
                  <div className="contact-department">{contact.department}</div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      
      <BottomNavigation showNavigation={true} />
    </div>
  );
}

export default Contacts;
